'use strict'
import ViewBase from '../../../view-base.view'
import { Dialog } from 'construct-ui'
import languageModel from '../../../../models/language.model';
import trainingImageModel from "../../../../models/custom-vision/custom-vision.training-images.model";
import tagModel from "../../../../models/custom-vision/custom-vision.tags.model";
import CVTrainingImagesAddView from '../training-images/custom-vision.training-images-add.view';
import CVTrainingImagesEditView from '../training-images/custom-vision.training-images-edit.view';
import paginationComponent from '../../../../components/pagination/pagination.component';

export default function CVTrainingImagesListView() {
    ViewBase.call(this);

    let inputDataModel = { searchImageIds: '', totalCount: 0, pageIndex: 1, pageSize: 12 };

    let isPopupAddNewTrainingImageOpened = false;
    let isPopupEditTrainingImageOpened = false;

    let selectedProjectId = 0;
    let selectedImageId  = 0;
    let trainingImages = [];
    let availableTags = [];
    let selectedProjectName = '';

    let _loadTrainingImages = () => {
        this.showLoading();

        trainingImageModel.getImagesList(
            (result) => {
                this.hideLoading();

                trainingImages = result.data;
                
                if (trainingImages == null || (trainingImages.length == 1 && trainingImages[0].imageId == 0)) {
                    trainingImages = [];
                }

                inputDataModel.totalCount = result.total;
                inputDataModel.pageIndex = result.pageIndex;
                inputDataModel.pageSize = result.pageSize;

            }, (error) => {
                this.hideLoading();

                this.handleError(error);
            },
            selectedProjectId, 
            inputDataModel.searchImageIds,
            inputDataModel.pageIndex, inputDataModel.pageSize);
    }

    let _onPageSizeChanged = (pageIndex, pageSize) => {
        inputDataModel.pageIndex = pageIndex;
        inputDataModel.pageSize = pageSize;
        _loadTrainingImages();
    }

    let _onPageChanged = (pageIndex) => {
        inputDataModel.pageIndex = pageIndex;
        _loadTrainingImages();
    }

    let _uploadNewTrainingImage = () => {
        isPopupAddNewTrainingImageOpened = true;
    }

    let _onUploadNewTrainingImageComplete = () => {
        isPopupAddNewTrainingImageOpened = false;        
        _loadTrainingImages();
        _loadTags();
    }

    let _editTrainingImage = (imageId) => {
        selectedImageId = imageId;
        isPopupEditTrainingImageOpened = true;
    }

    let _onEditTrainingImageComplete = () => {
        isPopupEditTrainingImageOpened = false;        
        _loadTrainingImages();
        _loadTags();
    }

    let _onDeactivateTrainingImageComplete = () => {
        isPopupEditTrainingImageOpened = false;        
        this.showMessage(this.getText("LT00000142XXX", "The image has been deleted."), this.getText("LT00000141XXX", "Delete Training Image"));

        _loadTrainingImages();    
        _loadTags();        
    }

    let _loadTags = () => {
        tagModel.getTagStatisticsList(
            _tagsListSuccessCallBack,
            _tagsListErrorCallBack,
            selectedProjectId
        );
    }

    let _tagsListSuccessCallBack = (result) => {
        availableTags = result;
        if (availableTags == null) {
            availableTags = [];
        }
    }

    let _tagsListErrorCallBack = () => {
        availableTags = [];
    }

    let _search = () => {
        let searchImageIds = '';
        let selectedTagCheckboxes = document.querySelectorAll('input[name=checkbox_tags]:checked');
        for(var i = 0; i < selectedTagCheckboxes.length; i++) {
            searchImageIds += ',' + selectedTagCheckboxes[i].value;
        }
        inputDataModel.searchImageIds = searchImageIds;
        _loadTrainingImages();
    }

    let _clearFilter = () => {
        inputDataModel.searchImageIds = '';
        let selectedTagCheckboxes = document.querySelectorAll('input[name=checkbox_tags]:checked');
        for(var i = 0; i < selectedTagCheckboxes.length; i++) {
            selectedTagCheckboxes[i].checked = false;
        }
        _loadTrainingImages();
    }

    return {
        oninit: (vnode) => {

            if(vnode.attrs.projectId && vnode.attrs.projectName){
                selectedProjectId = vnode.attrs.projectId;
                selectedProjectName = vnode.attrs.projectName;
                
                _loadTrainingImages();

                _loadTags();
            }
        },
        view: ({ attrs }) => {
            
            return [
                m('.col-md-12',
                    m('.d-flex', 
                        m('.flex-grow-1',
                            [
                                m('h2.mb-2', selectedProjectName),
                                m("a", { "href": "javascript:;", onclick:()=>{ attrs.showProjectsPage() } }, m("span", "< Back to Projects"))
                            ]
                        ),
                        m('div',
                            m('button.btn.btn-outline-primary',  
                                { onclick: _uploadNewTrainingImage }, [
                                    m("i.bi.bi-plus-lg.me-0")
                                ]
                                
                            )
                        )
                    )
                ),
                availableTags.length > 0 && m('.d-flex.justify-content-end.mb-2',
                    m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                        m('span.search-arrow.me-2',
                            m('i.bi.bi-search')
                        ), this.getText("LT00000001", "Search")
                    )
                ),
                availableTags.length > 0 && m('.card mb-3.searchbox.collapse[id="showSearchBarRc"]',
                    m('.card-body.py-3',
                        m('.row',
                            m('.container',                                

                                m('.col-md-6',
                                    m('label.form-label', this.getText("LT00000048XX", "Filter by Tags"))
                                ),
                                m(".col-md-12", m(".row", 
                                [
                                    availableTags.map(function (tag, index) {
        
                                        return m("div", { "class": "col-md-2", style: "margin-bottom: 24px;" },
                                            m(".form-check", [
                                                m("input.form-check-input", { type: "checkbox", id: "checkbox_tag_" + tag.id, name: "checkbox_tags", value: tag.id }),
                                                m("label", { for: "checkbox_tag_" + tag.id }, tag.name + " (" + tag.numberOfAttachedImages + ")")
                                            ])
                                        )
                                    })
                                ])),
                                m('.col-md-6.gap-2.d-sm-flex.mt-4',
                                    m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, this.getText("LT00000001", "Search")),
                                    m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                                ),
                            )
                        )
                    )
                ),
                m('.card.mb-3.mt-2', 
                    m('.card-body.py-3', 
                        m('.row', 
                            m('.container', [
                
                                m('div', { "class": "row" }, 
                                
                                    trainingImages.length == 0 &&
                                    m('span', this.getText("EM00000141", "No records found.")),
                                    
                                    trainingImages.length > 0 &&
                                    m(".col-md-12", m(".row", 
                                        [
                                            trainingImages.map(function (trainingImage, index) {
                
                                                let _hasRepresentivePicture = (trainingImage.fileContent != '' && trainingImage.fileContent != null);
                
                                                return _hasRepresentivePicture && m("div", { "class": "col-md-3", style: "margin-bottom: 24px;" },
                                                    [
                                                        m("img", { "src": trainingImage.fileContent, "style": "max-width: 100%; cursor: pointer;", onclick:()=>{ _editTrainingImage(trainingImage.imageId) } }),
                                                        m(".row", { style: "margin-top: 6px;" }, [
                                                            m(".col-8", [
                                                                m("div", [m("i", { "class": "bi bi-person" }), m("span", trainingImage.createUserName)]),
                                                                m("div", [m("i", { "class": "bi bi-clock" }), m("span", trainingImage.createDateDisplay)])
                                                            ]),
                                                            m(".col-4", m("button.btn.btn-white[type='button']", { onclick:()=>{ _editTrainingImage(trainingImage.imageId)  }}, languageModel.getText("LT00000022XXX", "Manage")))
                                                        ])
                                                    ]
                                                )
                                            })
                                        ]
                                    )),
                                    trainingImages.length > 0 && m(paginationComponent,
                                        {
                                            pageSizeChoise: [12, 24, 48, 100],
                                            currentPage: inputDataModel.pageIndex,
                                            pageSize: inputDataModel.pageSize,
                                            totalItems: inputDataModel.totalCount,
                                            onPageChanged: _onPageChanged,
                                            onPageSizeChanged: _onPageSizeChanged
                                        }
                                    )
                                )
                            ])
                        )
                    )
                ),
                m(Dialog, {
                    isOpen: isPopupAddNewTrainingImageOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupAddNewTrainingImageOpened = false; },
                    title: this.getText("LT00000058XX", "Upload New Training Image"),
                    content: m(CVTrainingImagesAddView, { 
                        onPopupClose: () => { isPopupAddNewTrainingImageOpened = false },
                        onSaveComplete: _onUploadNewTrainingImageComplete,
                        projectId: selectedProjectId
                    }),
                    "class": "cui-dialog-xxl"
                }),
                m(Dialog, {
                    isOpen: isPopupEditTrainingImageOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupEditTrainingImageOpened = false; },
                    title: this.getText("LT00000058XX", "Edit Training Image"),
                    content: m(CVTrainingImagesEditView, { 
                        onPopupClose: () => { isPopupEditTrainingImageOpened = false },
                        onSaveComplete: _onEditTrainingImageComplete,
                        onDeactivateComplete: _onDeactivateTrainingImageComplete,
                        projectId: selectedProjectId,
                        imageId: selectedImageId
                    }),
                    "class": "cui-dialog-xxl"
                }),
                
                this.getBaseViews()
            ];
        },
    };
}
